import { Controller } from "@hotwired/stimulus";

// Toggles the hearse line item in the coffin checkout cost summary when
// the carry / hearse radio buttons change. Scoped to the checkout page
// container so it never queries outside its own element.
export default class extends Controller {
  static targets = ["row"];

  static values = {
    carryGroup: String,
    hearseGroup: String,
  };

  connect() {
    this.onChange = this.onChange.bind(this);
    this.element.addEventListener("change", this.onChange);
    this.syncRowVisibility();
  }

  disconnect() {
    this.element.removeEventListener("change", this.onChange);
  }

  onChange(event) {
    const { target } = event;
    if (target?.type !== "radio") return;

    if (target.name === this.carryGroupValue || target.name === this.hearseGroupValue) {
      this.syncRowVisibility();
    }
  }

  syncRowVisibility() {
    if (!this.hasRowTarget) return;
    this.rowTarget.classList.toggle("hidden", !this.hearseWanted());
  }

  hearseWanted() {
    const checked = (name) =>
      this.element.querySelector(`input[type="radio"][name="${name}"]:checked`)?.value;

    return (
      checked(this.carryGroupValue) === "true" ||
      checked(this.hearseGroupValue) === "true"
    );
  }
}
